document.addEventListener('DOMContentLoaded', function () {
    const notyf = new Notyf();

    document.getElementById('telefone').addEventListener('input', function (e) {
        let x = e.target.value.replace(/\D/g, '').slice(0, 11);
        if (x.length > 10) {
            e.target.value = x.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
        } else {
            e.target.value = x.replace(/^(\d{2})(\d{4})(\d{0,4})$/, '($1) $2-$3');
        }
    });

    const form = document.getElementById('form-candidatura');
    const curriculoInput = document.getElementById('curriculo');
    const fileNameDisplay = document.getElementById('file-name');

    // Mostrar nome do arquivo selecionado
    if (curriculoInput) {
        curriculoInput.addEventListener('change', function () {
            const fileName = this.files[0] ? this.files[0].name : 'Nenhum arquivo escolhido';
            fileNameDisplay.textContent = fileName;
        });
    }

    // Validação dos campos
    form.addEventListener('submit', function (e) {
        e.preventDefault();
        let formValido = true;

        const campos = form.querySelectorAll('input, select');

        campos.forEach(input => {
            const isCheckbox = input.type === 'radio';
            const isFile = input.type === 'file';

            const valorVazio =
                (!isCheckbox && !isFile && !input.value.trim()) ||
                (isCheckbox && !input.checked) ||
                (isFile && input.files.length === 0);

            if (valorVazio) {
                input.classList.add('error');

                if (isCheckbox) {
                    input.closest('.d-flex')?.classList.add('error');
                }

                if (isFile) {
                    const fileLabel = form.querySelector(`label[for="${input.id}"]`);
                    fileLabel?.classList.add('error');
                }

                formValido = false;
            } else {
                input.classList.remove('error');

                if (isCheckbox) {
                    input.closest('.d-flex')?.classList.remove('error');
                }

                if (isFile) {
                    const fileLabel = form.querySelector(`label[for="${input.id}"]`);
                    fileLabel?.classList.remove('error');
                }
            }
        });

        if (formValido) {
            // Envio AJAX
            const url = form.getAttribute('data-url');
            const formData = new FormData(form);
            grecaptcha.ready(() => {
                grecaptcha.execute(document.getElementById("recaptcha").value, {
                    action: 'submit'
                }).then(token => {
                    formData.append('gRecaptchaResponse', token);
                    fetch(url, {
                        method: 'POST',
                        body: formData,
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                        },
                    })
                    .then(response => response.json())
                    .then(data => {
                        if (data.status) {
                            notyf.success(data.txt || 'Mensagem enviada com sucesso!');
                            form.reset();
                            fileNameDisplay.textContent = '';
                        } else {
                            notyf.error(data.txt || 'Erro ao enviar mensagem.');
                        }
                    })
                    .catch(() => {
                        notyf.error(data.txt || 'Erro ao enviar mensagem.');
                    });
                });
            });
        }
    });

    // Abrir modal
    document.querySelectorAll('.js-open-modal').forEach(card => {
        card.addEventListener('click', () => {
            const url = card.dataset.url;
            fetch(url)
                .then(response => response.text())
                .then(html => {
                    const modalContent = document.getElementById('modalDescricao');
                    modalContent.innerHTML = html;
                    const modalElement = document.getElementById('content_modal');
                    const modalInstance = bootstrap.Modal.getOrCreateInstance(modalElement);
                    modalInstance.show();
                    
                    // Adicionar listener para o botão "Candidatar-se" após o modal ser carregado
                    setTimeout(() => {
                        const candidatarBtn = document.querySelector('.js-candidatar-vaga');
                        if (candidatarBtn) {
                            candidatarBtn.addEventListener('click', function(e) {
                                e.preventDefault();
                                
                                // Capturar dados da vaga
                                const vagaId = this.getAttribute('data-vaga-id');
                                const vagaTitulo = this.getAttribute('data-vaga-titulo');
                                
                                // Fechar modal
                                modalInstance.hide();
                                
                                // Preencher o campo "Vaga de Interesse" na mesma página
                                const vagaSelect = document.getElementById('vaga-interesse');
                                if (vagaSelect) {
                                    // Criar nova opção se não existir
                                    let option = vagaSelect.querySelector(`option[value="${vagaTitulo}"]`);
                                    if (!option) {
                                        option = document.createElement('option');
                                        option.value = vagaTitulo;
                                        option.textContent = vagaTitulo;
                                        vagaSelect.appendChild(option);
                                    }
                                    vagaSelect.value = vagaTitulo;
                                }
                                
                                // Scroll para o formulário
                                setTimeout(() => {
                                    const formulario = document.querySelector('.form-vagas');
                                    if (formulario) {
                                        formulario.scrollIntoView({ 
                                            behavior: 'smooth',
                                            block: 'start'
                                        });
                                    }
                                }, 500);
                            });
                        }
                    }, 100);
                })
                .catch((e) => {
                    console.error('Erro ao carregar o modal:', e);
                });
        });
    });

    // Fechar modal
    const closeModalBtn = document.getElementById('close-modal');
    if (closeModalBtn) {
        closeModalBtn.addEventListener('click', () => {
            const modalElement = document.getElementById('content_modal');
            const modalInstance = bootstrap.Modal.getOrCreateInstance(modalElement);
            modalInstance.hide();
            document.getElementById('modalDescricao').innerHTML = '';
        });
    }

});
